var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.versiculos),function(versiculo){return _c('div',{key:versiculo.ver_vrs_id,staticClass:"p-1"},[_c('small',{staticClass:"mr-2"},[_vm._v(_vm._s(versiculo.ver_versiculo))]),_c('versiculo',{attrs:{"texto":versiculo.ver_texto}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }